// export const IS_REACT_NATIVE_ENABLED =
//   typeof window.ReactNativeWebView !== "undefined" &&
//   window.ReactNativeWebView !== null;

export const IS_REACT_NATIVE_ENABLED = false;
